// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  publicBaseUrl: 'https://develop-calypsoweb.imagineapps.co',
  backendUrl: 'https://develop-calypso-admin.imagineapps.co/',
  apiDaptaURL: 'https://api.dapta.ai/api/calypso-del-caribe-169-817-8/',
  apiDaptaUuidURL: 'https://api.dapta.ai/api/12631411804ccffb/',
  apiKey: 'LOhsC-12631411-eb41-4e62-958b-3dc5804ccffb-f',
  urlbucket: 'https://calypso-recursos-develop.s3.us-east-1.amazonaws.com/',
  urlcloudfront: 'https://d3lmpgbzzpep7j.cloudfront.net/',
  firebaseConfig: {
    apiKey: 'AIzaSyBFfJikc71dRhvSTgnFzF0Bqd0s2xN_bDU',
    authDomain: 'qmenu-qa.firebaseapp.com',
    databaseURL: 'https://qmenu-qa-default-rtdb.firebaseio.com',
    projectId: 'qmenu-qa',
    storageBucket: 'qmenu-qa.appspot.com',
    messagingSenderId: '809251249564',
    appId: '1:809251249564:web:e5591ce9a863958b9d3c59',
    measurementId: 'G-FVB5NBSFW4',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
